import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { FaTrophy } from "react-icons/fa";
import api from "../utils/api";

export default function LeaderboardContent() {
  const [page, setPage] = useState(1);
  const [attempt, setAttempt] = useState(0);
  const [result, setResult] = useState({ players: [], hasMore: false });
  const [state, setState] = useState("loading");
  const loggedIn = Boolean(localStorage.getItem("accessToken"));
  useEffect(() => {
    let mounted = true;
    if (!loggedIn) { setState("signin"); return; }
    setState("loading");
    api.get(`/auth/leaderboard?page=${page}`).then(({ data }) => {
      if (!mounted) return;
      setResult(data.data);
      setState("ready");
    }).catch(() => { if (mounted) setState("error"); });
    return () => { mounted = false; };
  }, [page, attempt, loggedIn]);

  return (
    <section className="bg-[#0b0720] py-12 text-white">
      <div className="max-w-[1100px] mx-auto px-4 sm:px-6">
        <div className="flex flex-wrap items-center justify-between gap-4 mb-7">
          <div className="flex items-center gap-4">
            <span className="rounded-2xl bg-yellow-400/10 p-4 text-yellow-400"><FaTrophy size={26} /></span>
            <div><h2 className="text-2xl sm:text-3xl font-bold">Player Rankings</h2><p className="text-sm text-gray-400 mt-1">Ranked by total points</p></div>
          </div>
          <span className="rounded-full border border-white/10 px-4 py-2 text-sm text-yellow-400">All time</span>
        </div>
        <div className="rounded-2xl border border-white/10 overflow-hidden bg-[#17172d] shadow-xl">
          {state === "signin" ? <p className="p-10 text-center"><Link className="text-yellow-400 underline" to="/games">Sign in to view the leaderboard</Link></p>
            : state === "loading" ? <p role="status" className="p-10 text-center text-gray-300">Loading rankings...</p>
            : state === "error" ? <div role="alert" className="p-10 text-center"><p>Unable to load rankings.</p><button className="mt-4 text-yellow-400 underline" onClick={() => setAttempt(value => value + 1)}>Try again</button></div>
            : result.players.length === 0 ? <p className="p-10 text-center text-gray-300">No players to show yet.</p>
            : <div className="overflow-x-auto"><table className="w-full text-left text-sm">
              <caption className="sr-only">Active players ranked by database points</caption>
              <thead className="bg-white/5 text-gray-400 uppercase text-xs tracking-wider"><tr><th scope="col" className="px-4 sm:px-6 py-4">Rank</th><th scope="col" className="px-4 sm:px-6 py-4">Player</th><th scope="col" className="px-4 sm:px-6 py-4 text-right">Points</th></tr></thead>
              <tbody className="divide-y divide-white/5">{result.players.map(player => <tr key={player.id} className={player.isCurrentUser ? "bg-yellow-400/10" : "hover:bg-white/5"}>
                <td className="px-4 sm:px-6 py-5"><span className={player.rank <= 3 ? "font-bold text-yellow-400" : "text-gray-400"}>#{player.rank}</span></td>
                <td className="px-4 sm:px-6 py-5 font-medium whitespace-nowrap">+{player.msisdn}{player.isCurrentUser && <span className="ml-3 rounded-full bg-yellow-400 px-2 py-1 text-[10px] font-bold text-black">YOU</span>}</td>
                <td className="px-4 sm:px-6 py-5 text-right font-bold text-green-400 tabular-nums">{Number(player.points ?? 0).toLocaleString("en-NG")}</td>
              </tr>)}</tbody>
            </table></div>}
        </div>
        {loggedIn && <div className="mt-5 flex items-center justify-between text-sm">
          <button disabled={page === 1 || state === "loading"} onClick={() => setPage(value => value - 1)} className="rounded-lg border border-white/20 px-4 py-2 disabled:opacity-40">Previous</button>
          <span className="text-gray-400">Page {page}</span>
          <button disabled={!result.hasMore || state !== "ready"} onClick={() => setPage(value => value + 1)} className="rounded-lg border border-white/20 px-4 py-2 disabled:opacity-40">Next</button>
        </div>}
      </div>
    </section>
  );
}
